




















import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

/**
 * Helpers
 */
import { sortByAsc } from "@/utils/sort-helpers";
import { addMinutes } from '@/utils/date-helpers';

/**
 * Components
 */
import BookingCalendar from "@/components/booking-resources/components/BookingCalendar.vue";

/**
 * API
 */
import bookingsAPI, { ResourceBookableTimeRange, ResourceBooking, BookingCategory } from "@/api/bookings";
import usersAPI from "@/api/users";
import servicesAPI, { ModePassage } from "@/api/services";


/** Page d'éditeur de réservations pour les agents. */
@Component({
	components: { BookingCalendar }
})
export default class BookingResourcesPage extends Vue {
	/** VueX - Snackbar */
	@Action('openInfo', { namespace: 'snackbar' })
	openInfo: any;
	@Action('openError', { namespace: 'snackbar' })
	openError: any;

	/** Attributs */
	isLoading = false;
	isActionLoading = false;

	// Les services possibles
	services: any[] = [];

	/** Méthodes */
	async created() {
		this.isLoading = true;
		await this.loadFilterDefinitionsData();
		this.isLoading = false;
	}

	async loadFilterDefinitionsData() {
		const currentUser = await usersAPI.getCurrent();
		const currentUserChildren = await usersAPI.getChildrenForBooking();

		const services = await servicesAPI.getAll(ModePassage.RESOURCES);

		this.services = services.sort(sortByAsc((x) => x.label));
	}


	async fetchDayBookableTimeRanges(day: number, month: number, year: number): Promise<ResourceBookableTimeRange[]> {
		return await bookingsAPI.getAllowedDayBookableTimeRanges(day, month, year);
	}

	// Doit retourner les réservations de tout le monde
	async fetchDayBookings(day: number, month: number, year: number): Promise<any[]> {
		const bookings = await bookingsAPI.getAll(year, month, day, BookingCategory.RESOURCES, true);
		return bookings.map((b) => ({
			startDate: new Date(Date.parse(b.bookedDate)),
			durationInMinutes: b.actualDurationInMinutes,
			service: b.service,
			user: b.user,
			state: b.state,
			isEditable: b.isEditable,
			isReadable: b.isReadable
		}));
	}
}
